export default __webpack_public_path__ + "static/media/weapon_detection.628d5a71.png";